import React, { useState } from 'react';
import { Form, Button, InputGroup } from 'react-bootstrap';
import { bookOpenIcon, eyeCloseIcon, eyeOpenIcon, facebookIcon, googleIcon } from '../../constants/icons';
import { Link, useNavigate } from 'react-router-dom';
import UserImage from "../../assets/images/bickey.jpg";

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (event) => {
    event.preventDefault();
    
    if (email && password) {
      localStorage.setItem('isLoggedIn', 'true');
      localStorage.setItem('user', JSON.stringify({ name: "Bickey Pujari", avatar: {UserImage} }));

      navigate('/');
    } else {
      alert("Please enter email and password.");
    }
  };

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="login-wrapper">
      <div className="login-container">
        <div className="login-logo-wrap">
          <div className="login-logo">
            {bookOpenIcon}
          </div>
          <h4>Examally</h4>
        </div>
        <h2 className="login-title">Login to your account</h2>
        <Form className="login-form" onSubmit={handleSubmit}>
          <Form.Group controlId="emailAddress">
            <Form.Label>Email address</Form.Label>
            <Form.Control
              type="email"
              placeholder="bickey.pujari@olivegroup.io"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Form.Group>

          <Form.Group controlId="password">
            <Form.Label>Password</Form.Label>
            <InputGroup>
              <Form.Control
                type={showPassword ? 'text' : 'password'}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <InputGroup.Text onClick={toggleShowPassword}>
                {showPassword ? eyeOpenIcon : eyeCloseIcon}
              </InputGroup.Text>
            </InputGroup>
          </Form.Group>

          <Form.Group controlId="chheckbox">
            <Form.Check
              className={`text-checkbox ${rememberMe ? 'active-checkbox' : ''}`}
              type="checkbox"
              label="Remember me"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
            />
          </Form.Group>

          <Button className="login-btn" variant="primary" type="submit">
            Login
          </Button>

          <Link className="forget-text" to="forgot-password">Forgot password?</Link>

          <div className="text-line-divider">
            <span>or</span>
          </div>

          <Form.Group className="social-login-wrap">
            <Button className="social-btn" variant="outline-primary">
              {facebookIcon} Login with Facebook
            </Button>
            <Button className="social-btn" variant="outline-primary">
              {googleIcon} Login with Google
            </Button>
          </Form.Group>
        </Form>
      </div>
    </div>
  );
}

export default Login;